const BOCOYMI = 'BOCOYMI';
const COYMS = 'COYMS';
const COYMAI = 'COYMAI';

const saveToStorage = (key, value) => {
    return localStorage.setItem(key, btoa(unescape(encodeURIComponent(JSON.stringify(value)))));
};

const getFromStorage = key => {
    const value = localStorage.getItem(key);
    if (!value) {
        return null;
    }
    return JSON.parse(decodeURIComponent(escape(atob(value))));
};

const defaultMenu = {
    items: [],
    section: {
        name: 'Dashboard',
        active: true,
        icon: 'fal fa-home',
        route: {
            name: 'dashboard'
        }
    }
};


// Cambios 19 nov

export const loadSavedData = ({ commit }) => {
    const newState = {};
    newState.items = getFromStorage(BOCOYMI) || defaultMenu.items;
    newState.section = getFromStorage(COYMS) || defaultMenu.section;
    newState.activeItem = getFromStorage(COYMAI) || defaultMenu.activeItem;
    commit('SET_ITEMS', newState.items);
    commit('SET_SECTION', newState.section);
    commit('SET_ACTIVE', newState.activeItem);
    return Promise.resolve(newState);
};

export const setItems = ({ commit }, items) => {
    commit('SET_ITEMS', items);
    saveToStorage(BOCOYMI, items);
    return Promise.resolve();
};

export const disableItemsMenu = ({ commit }) => {
    commit('SET_ALL_INACTIVE');
    return Promise.resolve();
};

export const disableItemsSubMenu = ({ commit, getters }) => {
    commit('SET_ALL_INACTIVE_CHILD', getters.activeItem);
    return Promise.resolve();
};

export const setSection = ({ commit }, section) => {
    section.active = true;
    commit('SET_SECTION', section);
    saveToStorage(COYMS, section);
    return Promise.resolve(section);
};

export const setActiveItem = ({ commit }, item) => {
    commit('SET_ACTIVE', item);
    saveToStorage(COYMAI, item);
    return Promise.resolve(item);
};

export const setActiveSubItem = ({ commit }, payload) => {
    commit('SET_ACTIVE_SUBITEM', payload);
    return Promise.resolve(payload);
};

export const removeItem = ({ commit, state }, index) => {
    commit('REMOVE_ITEM', index);
    saveToStorage(BOCOYMI, state.items);
    return Promise.resolve(index);
};

export const removeSubItem = ({ commit, getters, state }, index) => {
    const payload = {
        itemActive: getters.activeItem,
        itemActiveChildren: index
    };
    commit('REMOVE_SUBITEM', payload);
    saveToStorage(BOCOYMI, state.items);
    return Promise.resolve(index);
};

export const updateItemName = ({ commit, getters }, name) => {
    const payload = {
        index: getters.activeItem,
        name
    };
    commit('UPDATE_ITEM_NAME', payload);
    return Promise.resolve(name);
};

/**
 * Adds a new item to the array, checks if route is already in array.
 * @param {Object} - Action store object
 * @param {Object} item Item to be added
 */
export const upsertItem = ({ commit, getters, state }, item) => {
    // commit('SET_ALL_INACTIVE');

    if (getters.hasItem(item)) {
        commit('UPDATE_ITEM', item);
    } else {
        commit('INSERT_ITEM', item);
    }
    saveToStorage(BOCOYMI, state.items);
};

export const upsertSubItem = ({ dispatch, commit, getters, state }, payload) => {
    dispatch('disableItemsSubMenu')
        .then(() => {
            if (getters.hasItemInChildren(payload)) {
                commit('UPDATE_SUBITEM', payload);
            } else {
                commit('INSERT_SUBITEM', payload);
            }
            saveToStorage(BOCOYMI, state.items);
        });
};

export const updateSubItemName = ({ commit, getters }, name) => {
    const payload = {
        index: getters.activeItem,
        indexChildren: getters.activeSubItem,
        name
    };
    commit('UPDATE_SUB_ITEM_NAME', payload);
    return Promise.resolve(name);
};

export const reset = ({ commit }) => {
    commit('RESET');
    return Promise.resolve();
};
